import * as React from "react";
import { loadComponent } from "@amzn/legal-client-utilities";
import { AppContext } from "../../setup/context";
import { useCookieLoader } from "./useCookieLoader";

export const SourceMfePreloader = (props: {children}) => {
    const context = React.useContext(AppContext);
    const remoteEntryUrl = `${context.config.source.url}/remoteEntry.js`;
    const [loadError, setLoadError] = React.useState(null);
    const [scriptLoaded, setScriptLoaded] = React.useState(false);
    const cookieLoader = useCookieLoader(`${context.config.source.url}/cookie-proxy`);

    const fetchScript = () => {
        loadComponent("source2_provider", "./MatterSmartSearch", remoteEntryUrl , false)
            .catch(error => {
                console.error("Failed to load remote component:", error);
                setLoadError(error);
            })
            .then(d => {
                setScriptLoaded(true);
            });
    };

    React.useEffect(() => {
        if (cookieLoader.error) {
            // retry load mfe script
            fetchScript();
        }
    }, [cookieLoader.error]);

    React.useEffect(() => {
        if (!scriptLoaded) {
            fetchScript();
        } else if (scriptLoaded) {
            cookieLoader.run();
        }
    }, [scriptLoaded]);

    window["remotes"] = {
        source2_provider: remoteEntryUrl
    };

    if (loadError) {
        return <div>Error loading component: {loadError.message}</div>;
    }

    return (
        <ErrorBoundary>
            {!cookieLoader.ready && <div>Loading...</div>}
            {cookieLoader.ready && props.children}
        </ErrorBoundary>
    );
};

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return {
            hasError: true,
            error
        };
    }

    render() {
        if (this.state.hasError) {
            return <div>Failed to load component. Please try again later.</div>;
        }
        return this.props.children;
    }
}